import { watch, onBeforeUnmount } from 'vue'
import { useMusic } from './useMusic'

/**
 * musicGetter はリアクティブな getter（例: () => store.params?.music）
 * music がセットされたタイミングで pushMusic し、アンマウント時に popMusic する
 */
export function useMusicScopedReactive(musicGetter: () => string | undefined, activeGetter: () => boolean) {
  const { pushMusic, popMusic } = useMusic()
  let pushed = false

  // Play music when musicGetter returns true (e.g. when dialog is activated)
  watch(
    musicGetter,
    (music) => {
      if (music && !pushed) {
        pushMusic(music)
        pushed = true
      }
    },
    { immediate: true },
  )

  // Stop music when activeGetter returns false (e.g. when dialog is closed)
  watch(
    activeGetter,
    (visible) => {
      if (!visible && pushed) {
        popMusic()
        pushed = false
      }
    },
  )

  // Cleanup when component is unmounted
  onBeforeUnmount(() => {
    if (pushed) {
      popMusic()
    }
  })
}
